export function excludeNullUndefined<T>(
  x: T
): x is Exclude<T, null | undefined> {
  return x !== null && x !== undefined;
}
